import React, { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Card, Col, Row } from 'reactstrap';
import MainFilter from '../components/filters/MainFilter';
import { insightRequest } from '../helpers/requests';
import moment from 'moment';
// import BarComparison from './Templates/BarComparison';


const Insights = () => {
    const [filter, setFilter] = useState();
    const insights = useSelector((state) =>state.insights.insights)
    const [type, setType] = useState('daily');
    const [peakHours, setPeakHours] = useState([]);
    const dispatch = useDispatch();
    const updateFilter = (e) => {
      console.log("insightsFilter",e);
        setFilter(e);
    }

    const months = [
        {value: 1, label: "January", short: "Jan"},
        {value: 2, label: "Februaru", short: "Feb"},
        {value: 3, label: "March", short: "Mar"},
        {value: 4, label: "April", short: "Apr"},
        {value: 5, label: "May", short: "May"},
        {value: 6, label: "June", short: "Jun"},
        {value: 7, label: "July", short: "Jul"},
        {value: 8, label: "August", short: "Aug"},
        {value: 9, label: "September", short: "Sep"},
        {value: 10, label: "October", short: "Oct"},
        {value: 11, label: "November", short: "Nov"},
        {value: 12, label: "December", short: "Dec"}
      ];

    const fromTime = (time) => {
        time = parseInt(time)-1;
        return time<=12? time + (time===12? ":00 PM":":00 AM") : ("0"+(time-12)).slice(-2) + (time===24? ":00 AM":":00 PM");
      }

      const toTime = (time) => {
        time = parseInt(time);
        return time<=12? ("0"+time).slice(-2) + (time===12? ":00 PM":":00 AM") : ("0"+(time-12)).slice(-2) + (time===24? ":00 AM":":00 PM");
      }


    const getDuration = (value, currentCase=null) => {
        switch(type){
          case "daily":
            return fromTime(value) + " - " + toTime(value);
          case "days":
            if(typeof value === "string"){
              return fromTime(value) + " - " + toTime(value);
            }else{
              var arr = moment(value.date).format("llll").split(",");
              arr = [arr[0], arr[1]].join(",");
              return arr+" | "+fromTime(value.hour) + " - " + toTime(value.hour);
            }
          case "weekly":
            var arr = moment(value).format("llll").split(",");
            arr = [arr[0], arr[1]].join(",");
            return arr;
          case "monthly":
            //var arr = moment(previous.year.value+"/"+previous.month.value+"/"+value).format("llll").split(",");
            //var arr = moment(value).format("llll").split(",");
            //arr = [arr[0], arr[1]].join(",");
            var start = moment().year(filter.year.value).week(value).startOf("week").format('llll').split(",");
            var end = moment().year(filter.year.value).week(value).endOf("week").format('llll').split(",");
            var arr = [start[0], start[1]].join(",") + " - " + [end[0], end[1]].join(",");
            return arr;
          case "yearly":
            var value = parseInt(value);
            if(value === NaN || value === "NaN"){
              return "";
            }
            var val = "";
            try{
              val = months[value].short+", "+filter.year.value;
            }catch(e){
              console.log(e);
              val = "";
            }
            console.log(value);
            return val;
          case "avg_peak_hours":
            return fromTime(value) + " - " + toTime(value);
          case "avg_peak_hour":
            return fromTime(value) + " - " + toTime(value);
          case "peak_hours":
            if(typeof value === "string"){
              return fromTime(value) + " - " + toTime(value);
            }else{
              var arr = moment(value.date).format("llll").split(",");
              arr = [arr[0], arr[1]].join(",");
              return arr+" | "+fromTime(value.hour) + " - " + toTime(value.hour);
            }
          case "peak_days":
            var arr = moment(value).format("llll").split(",");
            arr = [arr[0], arr[1]].join(",");
            return arr;
          case "peak_weeks":
            //var arr = moment(previous.year.value+"/"+previous.month.value+"/"+value).format("llll").split(",");
            //var arr = moment(value).format("llll").split(",");
            //arr = [arr[0], arr[1]].join(",");
            var start = moment().year(filter.year.value).week(value).startOf("week").format('llll').split(",");
            var end = moment().year(filter.year.value).week(value).endOf("week").format('llll').split(",");
            var arr = [start[0], start[1]].join(",") + " - " + [end[0], end[1]].join(",");
            return arr;
          case "peak_months":
            var value = parseInt(value);
            if(value === NaN || value === "NaN"){
              return "";
            }
            var val = "";
            try{
              val = months[value].short+", "+filter.year.value;
            }catch(e){
              console.log(e);
              val = "";
            }
            console.log(value);
            return val;
          default:
            return "";
        }
      }
    
    useEffect(() => {


        if(filter) {
            let obj = {...filter, dispatch}
            insightRequest(obj)
        }
    }, [filter])

    useEffect(() => {
        if(insights != null) {
          let data =  insights?.peak_hours?.map((val, index)=>{ return getDuration(typeof val._id === "string"?val._id : ""+val._id.hour, 'daily')})
            setPeakHours(data);
        }

    }, [insights])


    return (
        <Fragment>
            <MainFilter pageTitle="Insights" updateFilter = {(e) => updateFilter(e)} type='premium'></MainFilter>
            {
                type === "daily" &&
                <Row>
                    <Col>
                    {insights &&insights?.peak_hours && peakHours && peakHours?.length && insights?.peak_hours?.length &&
                    // <BarComparison cardTitle="Peak Hours"  data={insights?.peak_hours?.map((val, index)=>{return val?.total}) } labels={peakHours?.length? insights?.peak_hours?.map((hour,index) =>peakHours[index] ) : null} />
                    
                    <Card className='' >
                        <h5>Peak Hours</h5>
                        {insights?.peak_hours?.map((hour,index) => (
                            <div>
                                {peakHours[index] } : {hour.total}
                            </div>
                        ))}

                    </Card>
                }

                    </Col>
                </Row>
            }

        </Fragment>
    )
}

export default Insights;